<template>
    <v-card color="grey lighten-4" elevation="0" v-bind="{ class: { 'px-12 py-8': !$vuetify.breakpoint.mobile } }">
        <v-card-title
            class="tit tit--sm primary--text"
            :class="{
                'justify-center': $vuetify.breakpoint.mobile,
            }"
        >
            교환권 번호
        </v-card-title>
        <v-card-text>
            <v-row class="row--small">
                <template v-for="item in items">
                    <v-col cols="12" :key="item.tempId">
                        <v-row no-gutters align="center">
                            <v-col>
                                <v-text-field v-model="item.prev" flat dense solo hide-details placeholder="교환권 번호를 입력해주세요." clearable v-bind="{ class: { 'text-center': $vuetify.breakpoint.mobile } }" @input="emit" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn icon tile v-bind="{ disabled: items.length == 1 }" style="background:transparent !important" @click="pull(item)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </template>
                <v-col cols="12">
                    <v-btn x-large text block v-bind="{ disabled: items.length == 10 }" @click="push">
                        <span class="font-weight-bold"> 입력란 추가 </span>
                        <v-icon class="ml-2" size="20">mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { initUserExchange, USER_EXCHANGE_CODES } from "@/assets/lib";

export default {
    props: {
        value: {
            /** @type {import('vue').PropType<import('@/assets/lib').UserExchange[]>} */
            type: Array,
            default: () => [],
        },
        code: { type: String, default: USER_EXCHANGE_CODES.AUCTION.value.toLowerCase() },
    },
    data: () => ({
        /** @type {import('@/assets/lib').UserExchange[]} */
        items: [],
    }),
    methods: {
        sync() {
            this.items = [...this.value].map(initUserExchange);
        },
        emit() {
            this.$emit("input", this.items);
        },

        push() {
            let code = this.code.toUpperCase();
            this.items.push(initUserExchange({ code }));
            this.emit();
        },
        /** @param {import('@/assets/lib').UserExchange} item */
        pull(item) {
            let index = this.items.findIndex(({ tempId }) => tempId == item.tempId);
            if (-1 < index) this.items.splice(index, 1);
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.text-center ::v-deep input {
    text-align: center;
}
</style>
